import { BAOCustomElement } from '@bao/custom-element'
import { setInitialised, addWheelControls, useArrows } from '@bao/carousel'

const KeenSlider = window.KeenSlider

class CssCarousel extends BAOCustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    this.carousel?.destroy()
    this.carousel = null
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1000,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 'auto',
          spacing: this.dataset.mobileSpacing || 0,
        },
        breakpoints: {
          '(min-width: 901px)': {
            slides: {
              perView: 'auto',
              spacing: this.dataset.desktopSpacing || 0,
            },
          },
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
        addWheelControls('horizontal'),
      ],
    )
  }
}

if (!customElements.get('css-carousel')) {
  customElements.define('css-carousel', CssCarousel)
}
